import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IconUserUnassigned } from "@/components/_icons/IconUserUnassigned";
import { cn } from "@/lib/cn";

interface UserViewEmptyProps {
  logoOnly?: boolean;
  className?: string;
}

export const UserViewEmpty: FC<UserViewEmptyProps> = (props) => {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-row items-center gap-2">
      <IconUserUnassigned className={cn(["h-4 w-4", props.className])} />
      {!props.logoOnly && <div className="whitespace-nowrap">{t("notAssigned")}</div>}
    </div>
  );
};
